module.exports = __webpack_public_path__ + "img/500bg.bbbba6a4.png";